import { render, staticRenderFns } from "./ModalCustomerMessage.vue?vue&type=template&id=8b28e1b0"
import script from "./ModalCustomerMessage.vue?vue&type=script&lang=js"
export * from "./ModalCustomerMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports